export enum CutterActionType {
  NewFile = 'NewFile',
  Deselect = 'Deselect',
  Crop = 'Crop',
  Remove = 'Remove',
  Undo = 'Undo',
  Redo = 'Redo',
  ZoomIn = 'ZoomIn',
  ZoomOut = 'ZoomOut',
  ZoomReset = 'ZoomReset',
  Autoplay = 'Autoplay',
  Download = 'Download',
}
